function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["views", "format"];
import { resolveTimeFormat, isTimeView, isInternalTimeView } from "./time-utils.js";
import { isDatePickerView, resolveDateFormat } from "./date-utils.js";
export var resolveDateTimeFormat = function resolveDateTimeFormat(utils, _ref, ignoreDateResolving) {
  var views = _ref.views,
    format = _ref.format,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (format) {
    return format;
  }
  var dateViews = [];
  var timeViews = [];
  views.forEach(function (view) {
    if (isTimeView(view)) {
      timeViews.push(view);
    } else if (isDatePickerView(view)) {
      dateViews.push(view);
    }
  });
  if (timeViews.length === 0) {
    return resolveDateFormat(utils, _extends({
      views: dateViews
    }, other), false);
  }
  if (dateViews.length === 0) {
    return resolveTimeFormat(utils, _extends({
      views: timeViews
    }, other));
  }
  var timeFormat = resolveTimeFormat(utils, _extends({
    views: timeViews
  }, other));
  var dateFormat = ignoreDateResolving ? utils.formats.keyboardDate : resolveDateFormat(utils, _extends({
    views: dateViews
  }, other), false);
  return "".concat(dateFormat, " ").concat(timeFormat);
};
var resolveViews = function resolveViews(ampm, views, shouldUseSingleColumn) {
  if (shouldUseSingleColumn) {
    return views.filter(function (view) {
      return !isInternalTimeView(view) || view === 'hours';
    });
  }
  return ampm ? [].concat(_toConsumableArray(views), ['meridiem']) : views;
};
var resolveShouldRenderTimeInASingleColumn = function resolveShouldRenderTimeInASingleColumn(timeSteps, threshold) {
  var _timeSteps$hours, _timeSteps$minutes;
  return 24 * 60 / (((_timeSteps$hours = timeSteps.hours) !== null && _timeSteps$hours !== void 0 ? _timeSteps$hours : 1) * ((_timeSteps$minutes = timeSteps.minutes) !== null && _timeSteps$minutes !== void 0 ? _timeSteps$minutes : 5)) <= threshold;
};
export function resolveTimeViewsResponse(_ref2) {
  var inThreshold = _ref2.thresholdToRenderTimeInASingleColumn,
    ampm = _ref2.ampm,
    inTimeSteps = _ref2.timeSteps,
    views = _ref2.views;
  var thresholdToRenderTimeInASingleColumn = inThreshold !== null && inThreshold !== void 0 ? inThreshold : 24;
  var timeSteps = _extends({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, inTimeSteps);
  var shouldRenderTimeInASingleColumn = resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
  return {
    thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
    timeSteps: timeSteps,
    shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
    views: resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
  };
}